import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { postDataAPI } from '../lib/api'
import BrandLogo from '../components/BrandLogo'

export default function ProtectPage() {
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!password) return
    setError(null)
    setIsLoading(true)

    try {
      const res = await postDataAPI('auth/protect', { password })
      if (res?.status === 200) {
        localStorage.setItem('dizeeProtected', 'true')
        navigate('/')
      } else {
        setError(res?.message || 'Incorrect password')
      }
    } catch (err: any) {
      setError(err?.response?.data?.message || 'Incorrect password')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-8">
      <div className="w-full max-w-md">
        <div className="mb-10">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-5 h-5 bg-[#FF2300] rounded-sm flex-shrink-0"></div>
            <BrandLogo className="h-3 w-auto text-gray-900 dark:text-white" />
          </div>
          <p className="text-sm text-gray-500">Enter password to continue</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm mb-2">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoFocus
              className="ds-input"
            />
          </div>
          {error && <div className="text-red-600 text-sm">{error}</div>}
          <button
            type="submit"
            disabled={isLoading || !password}
            className="ds-btn ds-btn-primary w-full disabled:opacity-50"
          >
            {isLoading ? 'Verifying...' : 'Continue'}
          </button>
        </form>
      </div>
    </div>
  )
}
